module.exports = __webpack_public_path__ + "static/media/illustration-medical-clipboard-form.62b3e82f.svg";